/*
 * @author        joseph.murphy@zumper.com (murph)
 * @copyright     Copyright (c) 2023, Zumper
 */

import { AnalyticsC, Origin } from '@zcode/nr-utils'
import type { FloorplanListing, NormalFloorplanListingData } from '@zcode/state-type'
import React from 'react'
import { MessageBarLoadable } from '../../components/MessageBar/MessageBarLoadable'

export const EngrainMessageBarLoadable = ({
  selectedFloorplan,
}: {
  selectedFloorplan?: FloorplanListing<NormalFloorplanListingData>
}) => {
  return (
    <MessageBarLoadable
      analyticChannel={AnalyticsC.FULL_DETAIL}
      isEngrain
      isFixed
      origin={Origin.ENGRAIN}
      selectedFloorplan={selectedFloorplan}
    />
  )
}
